import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

const getHeaders = (extraHeaders = {}) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };

    if (
        decodedToken?.roles?.includes("TENANT_ADMIN") ||
        decodedToken?.subTenantId === undefined
    ) {
        headers["tenant-login"] = true;
    }

    // merge additional headers passed at call time
    return { ...headers, ...extraHeaders };
};

const getSubTenantDTO = () => {
    return decodedToken?.isMultitenancy && decodedToken?.subTenantId
        ? { id: decodedToken.subTenantId }
        : null;
};

const StorageListApi = {
    // Create Storage Api
    CreateStorage: (data) => {
        const jsonData = JSON.parse(data);
        const subTenantDTO = getSubTenantDTO();
        if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

        return apiApp
            .post(`/storages`, jsonData, { headers: getHeaders() })
            .then((res) => res.data)
            .catch((err) => Promise.reject(err.response?.data));
    },

    // Put Storage Api
    Putstorage: (storageID, data) => {
        const jsonData = JSON.parse(data);
        const subTenantDTO = getSubTenantDTO();
        if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

        return apiApp
            .put(`/storages/${storageID}`, jsonData, { headers: getHeaders() })
            .then((res) => res.data)
            .catch((err) => Promise.reject(err.response?.data));
    },

    // Single Storage Api
    Singlestorage: (storageID) => {
        return apiApp
            .get(
                `/storages/${storageID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err.response?.data));
    },

    // List Storage Api
    ListStorage: (page, limit) => {
        const query =
            page === undefined && limit === undefined
                ? `/storages?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`
                : `/storages?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;

        return apiApp
            .get(query, { headers: getHeaders() })
            .then((res) => res.data)
            .catch((err) => Promise.reject(err.response?.data));
    },

    // Delete Storage Api
    DeleteStorage: (StorageeID) => {
        return apiApp
            .delete(
                `/storages/${StorageeID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                { headers: getHeaders() }
            )
            .then((res) => res.data)
            .catch((err) => Promise.reject(err.response?.data));
    },
};

export default StorageListApi;
